var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"home",attrs:{"id":"home"}},[_c('public-header',{attrs:{"isHome":true}}),_c('v-main',[_c('router-view')],1),_c('public-footer',{attrs:{"isHome":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }